import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

import { useLocation } from "react-router-dom";

const RuntimeContext = createContext({
  isFlutterWebView: false,
  runtime: "web", // "web" | "flutter"
});

function detectFlutterByUA() {
  const ua = navigator.userAgent || "";
  return ua.includes("HallAppFlutterWebView") || ua.includes("HallAppFlutter");
}

// Só funciona se for flutter_inappwebview (não é o seu caso atual)
function detectFlutterByBridge() {
  return typeof window !== "undefined" && !!window.flutter_inappwebview;
}

function detectFlutterByStorage() {
  try {
    return localStorage.getItem("hallapp-runtime") === "flutter";
  } catch {
    return false;
  }
}

/**
 * ✅ lê "from=app" tanto de:
 * - location.search (Router normal)
 * - window.location.hash (HashRouter)
 */
function detectFlutterByQuery(search) {
  // 1) query normal
  try {
    const qs = new URLSearchParams(search || "");
    const from = qs.get("from");
    if (from === "flutter" || from === "app") return true;
  } catch {}

  // 2) query no hash: "#/sso?from=app&token=..."
  try {
    const hash = window.location.hash || "";
    const idx = hash.indexOf("?");
    if (idx >= 0) {
      const qsHash = new URLSearchParams(hash.slice(idx + 1));
      const fromHash = qsHash.get("from");
      if (fromHash === "flutter" || fromHash === "app") return true;
    }
  } catch {}

  return false;
}

export function RuntimeProvider({ children }) {
  const location = useLocation();
  const [isFlutterWebView, setIsFlutterWebView] = useState(() => detectFlutterByStorage());

  useEffect(() => {
    const byUA = detectFlutterByUA();
    const byBridge = detectFlutterByBridge();
    const byQuery = detectFlutterByQuery(location.search);
    const byStorage = detectFlutterByStorage();

    const detected = byUA || byBridge || byQuery || byStorage;

    setIsFlutterWebView(detected);

    // ✅ só grava "flutter" quando detectar flutter
    // ✅ não sobrescreve "web" e não mata o valor setado pelo /sso
    if (detected) {
      try {
        localStorage.setItem("hallapp-runtime", "flutter");
      } catch {}
    }
  }, [location.search]);

  const value = useMemo(() => {
    return {
      isFlutterWebView,
      runtime: isFlutterWebView ? "flutter" : "web",
    };
  }, [isFlutterWebView]);

  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useRuntime() {
  return useContext(RuntimeContext);
}
